import axiosInstance from "auth/FetchInterceptor";
import {
  SETTING_STORE_CATEGORY_API,
  GET_CURRENCY_LIST,
  SETTING_MENU_CATEGORY_API,
  SETTING_STORE_UTILITY_API,
  SETTING_PRODUCT_ATTRIBUTE,
  SETTING_BANNER,
  SETTING_PRIVACY,
  SETTING_TERM_CONDITION,
  SETTING_GROUP_CATEGORY_API,
  SETTING_RATING_CATEGORY_API,
  GET_SETTING_RATE,
  SETTING_AFFILIATE,
  GET_BANK_QR,
  SETTING_ARTIFICIAL_INTELLIGENCE,
  SETTING_MENU_STORE,
  SORT_MENU_CATEGORY_API,
  SETTING_PROCESS_PARTNER,
  SETTING_PROCESS_PARTNER_ALL,
  SETTING_PARTNER_ORDER,
  SETTING_PARTNER_ORDER_ALL,
  GET_STORE_BANK,
  UPDATE_STORE_BANK,
  SETTING_PAYMENT_GATEWAY,
  SETTING_STORE_CASH,
  SETTING_PRINTER_PARTNER,
  SETTING_PRINTER_PARTNER_ALL,
  SETTING_PRODUCT_PARTNER,
  SETTING_VOUCHER_PARTNER_LIST,
  SETTING_VOUCHER_PARTNER,
  EXPORT_VOUCHER_PARTNER_EXCEL,
  VOUCHER_GEN_CODE_PARTNER,
  APPLY_VOUCHER_STORE,
  STORE_VAT,
  STORE_VOUCHER_REWARD,
} from "constants/ApiConstant";
const SettingService = {};

//Store Category
SettingService.GetAllStoreCate = function () {
  return axiosInstance.get(SETTING_STORE_CATEGORY_API, null);
};
SettingService.AddStoreCate = function (data) {
  return axiosInstance.post(SETTING_STORE_CATEGORY_API, data);
};
SettingService.UpdateStoreCate = function (data) {
  return axiosInstance.put(SETTING_STORE_CATEGORY_API, data);
};
SettingService.DeleteStoreCate = function (id) {
  return axiosInstance.delete(`${SETTING_STORE_CATEGORY_API}/${id}`, null);
};

//Store Menu Category
SettingService.GetAllMenuCate = function () {
  return axiosInstance.get(SETTING_MENU_CATEGORY_API, null);
};
SettingService.AddMenuCate = function (data) {
  return axiosInstance.post(SETTING_MENU_CATEGORY_API, data);
};
SettingService.UpdateMenuCate = function (data) {
  return axiosInstance.put(SETTING_MENU_CATEGORY_API, data);
};
SettingService.DeleteMenuCate = function (id) {
  return axiosInstance.delete(`${SETTING_MENU_CATEGORY_API}/${id}`, null);
};
SettingService.SortMenuCate = function (data) {
  return axiosInstance.put(SORT_MENU_CATEGORY_API, data);
};

//Store Utility
SettingService.GetAllStoreUtility = function () {
  return axiosInstance.get(SETTING_STORE_UTILITY_API, null);
};

SettingService.AddStoreUtility = function (data) {
  return axiosInstance.post(SETTING_STORE_UTILITY_API, data);
};
SettingService.UpdateStoreUtility = function (data) {
  return axiosInstance.put(SETTING_STORE_UTILITY_API, data);
};
SettingService.DeleteStoreUtility = function (id) {
  return axiosInstance.delete(`${SETTING_STORE_UTILITY_API}/${id}`, null);
};

//Product Attribute
SettingService.getProductAttribute = function () {
  return axiosInstance.get(SETTING_PRODUCT_ATTRIBUTE, null);
};

SettingService.GetStoreBanner = function () {
  return axiosInstance.get(SETTING_BANNER, null);
};
SettingService.AddStoreBanner = function (data) {
  return axiosInstance.post(SETTING_BANNER, data);
};
SettingService.UpdateStoreBannerState = function (data) {
  return axiosInstance.put(`${SETTING_BANNER}/change-status`, data);
};
SettingService.UpdateStoreBanner = function (data) {
  return axiosInstance.put(SETTING_BANNER, data);
};
SettingService.DeleteStoreBanner = function (id) {
  return axiosInstance.delete(`${SETTING_BANNER}/${id}`, null);
};

// System setting
SettingService.GetTermCondition = function () {
  return axiosInstance.get(SETTING_TERM_CONDITION, null);
};
SettingService.GetPrivacy = function () {
  return axiosInstance.get(SETTING_PRIVACY, null);
};
SettingService.GetBankList = function () {
  return axiosInstance.get(GET_BANK_QR, null);
};

SettingService.GetStoreBank = function (storeId) {
  return axiosInstance.post(GET_STORE_BANK, { storeId });
};

SettingService.UpdateStoreBank = function (data) {
  return axiosInstance.put(UPDATE_STORE_BANK, data);
};

SettingService.GetPaymentGateway = function (storeId) {
  return axiosInstance.get(`${SETTING_PAYMENT_GATEWAY}/${storeId}`, null);
};

SettingService.UpdatePaymentGateway = function (data) {
  return axiosInstance.post(SETTING_PAYMENT_GATEWAY, data);
};

SettingService.GetStoreCash = function (storeId) {
  return axiosInstance.get(`${SETTING_STORE_CASH}/${storeId}`, null);
};

SettingService.UpdateStoreCash = function (data) {
  return axiosInstance.put(SETTING_STORE_CASH, data);
};

// Group category setting
SettingService.GetAllGroupCate = function () {
  return axiosInstance.get(SETTING_GROUP_CATEGORY_API, null);
};

SettingService.AddGroupCate = function (data) {
  return axiosInstance.post(SETTING_GROUP_CATEGORY_API, data);
};

SettingService.UpdateGroupCate = function (data) {
  return axiosInstance.put(SETTING_GROUP_CATEGORY_API, data);
};

SettingService.DeleteGroupCate = function (id) {
  return axiosInstance.delete(`${SETTING_GROUP_CATEGORY_API}/${id}`, null);
};

// Rating category setting
SettingService.GetAllRatingCate = function () {
  return axiosInstance.get(SETTING_RATING_CATEGORY_API, null);
};

SettingService.GetSettingRate = function () {
  return axiosInstance.get(GET_SETTING_RATE, null);
};

SettingService.UpdateSettingRate = function (data) {
  return axiosInstance.put(GET_SETTING_RATE, data);
};

SettingService.AddRatingCate = function (data) {
  return axiosInstance.post(SETTING_RATING_CATEGORY_API, data);
};

SettingService.UpdateRatingCate = function (data) {
  return axiosInstance.put(SETTING_RATING_CATEGORY_API, data);
};

SettingService.DeleteRatingCate = function (id) {
  return axiosInstance.delete(`${SETTING_RATING_CATEGORY_API}/${id}`, null);
};

// Affiliate setting
SettingService.GetAffiliateSetting = function () {
  return axiosInstance.get(SETTING_AFFILIATE, null);
};

SettingService.UpdateAffiliateSetting = function (data) {
  return axiosInstance.put(SETTING_AFFILIATE, data);
};

// Artificial intelligence setting
SettingService.GetArtificialIntelligence = function () {
  return axiosInstance.get(SETTING_ARTIFICIAL_INTELLIGENCE, null);
};

SettingService.UpSetArtificialIntelligence = function (data) {
  return axiosInstance.post(SETTING_ARTIFICIAL_INTELLIGENCE, data);
};

//Menu store
SettingService.GetAllMenuStore = function (data) {
  return axiosInstance.get(`${SETTING_MENU_STORE}/${data.storeId}`, null);
};
SettingService.AddMenuStore = function (data) {
  return axiosInstance.post(SETTING_MENU_STORE, data);
};
SettingService.UpdateMenuStore = function (data) {
  return axiosInstance.put(SETTING_MENU_STORE, data);
};
SettingService.DeleteMenuStore = function (data) {
  return axiosInstance.delete(`${SETTING_MENU_STORE}/${data.id}`, null);
};
SettingService.SortMenuStore = function (data) {
  return axiosInstance.put(`${SETTING_MENU_STORE}/sort`, data);
};

// Partner operating process setting
SettingService.GetPartnerProcess = function (partnerId) {
  return axiosInstance.get(`${SETTING_PROCESS_PARTNER}/${partnerId}`);
};

SettingService.UpsertPartnerProcess = function (data) {
  return axiosInstance.post(SETTING_PROCESS_PARTNER, data);
};

SettingService.UpsertAllPartnerProcess = function (data) {
  return axiosInstance.post(SETTING_PROCESS_PARTNER_ALL, data);
};

// Partner order feature setting
SettingService.GetPartnerOrder = function (partnerId) {
  return axiosInstance.get(`${SETTING_PARTNER_ORDER}/${partnerId}`);
};

SettingService.UpsertPartnerOrder = function (data) {
  return axiosInstance.put(SETTING_PARTNER_ORDER, data);
};

SettingService.UpsertAllPartnerOrder = function (data) {
  return axiosInstance.put(SETTING_PARTNER_ORDER_ALL, data);
};

// Partner printer template setting
SettingService.GetPartnerPrinter = function (partnerId) {
  return axiosInstance.get(`${SETTING_PRINTER_PARTNER}/${partnerId}`);
};

SettingService.UpsertPartnerPrinter = function (data) {
  return axiosInstance.post(SETTING_PRINTER_PARTNER, data);
};

SettingService.UpsertAllPartnerPrinter = function (data) {
  return axiosInstance.post(SETTING_PRINTER_PARTNER_ALL, data);
};

// Partner product display setting
SettingService.GetPartnerProductDisplay = function (partnerId) {
  return axiosInstance.get(`${SETTING_PRODUCT_PARTNER}/${partnerId}`);
};

SettingService.UpsertPartnerProductDisplay = function (data) {
  return axiosInstance.post(SETTING_PRODUCT_PARTNER, data);
};

// Partner voucher setting
SettingService.GetPartnerVoucherCode = function () {
  return axiosInstance.get(VOUCHER_GEN_CODE_PARTNER);
};

SettingService.GetPartnerVouchers = function (data) {
  return axiosInstance.post(SETTING_VOUCHER_PARTNER_LIST, data);
};

SettingService.GetPartnerVoucher = function (voucherId) {
  return axiosInstance.get(`${SETTING_VOUCHER_PARTNER}/${voucherId}`);
};

SettingService.ExportPartnerVoucherExcel = function (voucherId) {
  return axiosInstance.get(`${EXPORT_VOUCHER_PARTNER_EXCEL}/${voucherId}`, {
    responseType: "blob",
  });
};

SettingService.UpsertPartnerVoucher = function (data) {
  return axiosInstance.post(SETTING_VOUCHER_PARTNER, data);
};

SettingService.CancelPartnerVoucher = function (voucherId) {
  return axiosInstance.put(`${SETTING_VOUCHER_PARTNER}/${voucherId}`);
};

SettingService.ApplyPartnerVoucherToStores = function (data) {
  return axiosInstance.post(APPLY_VOUCHER_STORE, data);
};

// Store VAT setting
SettingService.GetStoreVat = function (storeId) {
  return axiosInstance.get(`${STORE_VAT}/${storeId}`);
};

SettingService.UpsertStoreVat = function (data) {
  return axiosInstance.post(STORE_VAT, data);
};

// Store voucher and reward setting
SettingService.GetStoreVoucherReward = function (storeId) {
  return axiosInstance.get(`${STORE_VOUCHER_REWARD}/${storeId}`);
};

SettingService.UpdateStoreVoucherReward = function (data) {
  return axiosInstance.put(STORE_VOUCHER_REWARD, data);
};

SettingService.getCurrencyList = () => axiosInstance.get(GET_CURRENCY_LIST);

export default SettingService;
